import React from "react";
import FormControlLabel from '@proofpoint/fuse/components/FormControlLabel';
import Radio from '@proofpoint/fuse/components/Radio';

const Cartridge = ({cartridge, checked}) => {
  return (
    <FormControlLabel value={cartridge.major_version} checked={checked} control={<Radio />} label={cartridge.major_version} />
  );
};

export default Cartridge;
